import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-leave-shared-billing-dialog',
  imports: [MatButtonModule, MatDialogModule],
  template: `
    <h2 mat-dialog-title>Leave shared billing?</h2>
    <mat-dialog-content>
      <p id="leave-shared-billing-description">
        Your usage will return to your personal account. Your own Free or Pro plan will apply,
        including any Free plan limits.
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button matButton type="button" [mat-dialog-close]="false">Cancel</button>
      <button matButton="filled" type="button" [mat-dialog-close]="true">Leave shared billing</button>
    </mat-dialog-actions>
  `,
})
export class LeaveSharedBillingDialogComponent {}
